import { LinkHTMLAttributes, DetailedHTMLProps } from 'react';

import { Helmet } from 'react-helmet';

import ACFImage from 'types/ACFImage';

type YoastSEOProps = {
  canonical?: string,
  description?: string
  og_description?: string,
  og_image?: any
  og_title?: string,
  title?: string,
  twitter_description?: string,
  twitter_image?: ACFImage,
  twitter_title?: string
}

const YoastSEO = ({
  title,
  description,
  canonical,
  og_title,
  og_description,
  og_image,
  twitter_title,
  twitter_description,
  twitter_image,
}:YoastSEOProps) => <Helmet
  title={ title ? title : 'When I Work | Employee Scheduling & Time Tracking Software' }
  meta={ [
    {
      name: 'description',
      content: `${
        description ?? 'When I Work is easy-to-use employee scheduling and time clock software. Simplify the shift and start your free 14-day trial today!'
      }`,
    },
    {
      property: 'og:title',
      content: `${
        og_title
          ? og_title
          : title
      }`,
    },
    {
      property: 'og:description',
      content: `${
        og_description
          ? og_description
          : description ?? 'When I Work is easy-to-use employee scheduling and time clock software. Simplify the shift and start your free 14-day trial today!'
      }`,
    },
    {
      property: 'og:image',
      content: `${
        og_image && og_image[0].url
          ? og_image[0].url.source_url
          : 'https://marketing-assets.wheniwork-production.com/2020/07/27183211/general.jpg'
      }`,
    },
    {
      property: 'og:url',
      content: `${canonical ?? process.env.GATSBY_SITE_URL}`,
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'twitter:title',
      content: `${
        twitter_title
          ? twitter_title
          : title
      }`,
    },
    {
      property: 'twitter:description',
      content: `${
        twitter_description
          ? twitter_description
          : description ?? 'When I Work is easy-to-use employee scheduling and time clock software. Simplify the shift and start your free 14-day trial today!'
      }`,
    },
    {
      property: 'twitter:image',
      content: `${
        twitter_image
          ? twitter_image.source_url
          : 'https://marketing-assets.wheniwork-production.com/2020/07/27183211/general.jpg'
      }`,
    },
    {
      property: 'twitter:site',
      content: '@wheniwork',
    },
    {
      property: 'twitter:card',
      content: 'summary_large_image',
    },
  ] }
  link={ [
        {
          rel: 'canonical',
          href: `${canonical}`,
          'data-baseprotocol': 'https:',
          'data-basehost': `${process.env.GATSBY_SITE_URL}`,
        } as DetailedHTMLProps<LinkHTMLAttributes<HTMLLinkElement>, HTMLLinkElement>,
    // using `as` since the types don't allow for custom attributes
  ] }
/>;

export default YoastSEO;
